import axiosClient from "../axios-client";
import { getAgentSuccess, getSessionSuccess, getReportTransactionSuccess, getUserSuccess } from "../reducers/supportReducer";
import { toastMessage } from "../toaster/toaster";
import { changeLoaderStatus } from "./loaderAction";


// ===============================================================================
// =================================== GET API ===================================
// ===============================================================================

export const getTicketDetails = async (dispatch, ticket_number) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/support/ticket-details/${ticket_number}`)
        .then((res) => {
            toastMessage("Ticket detail retrived successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Ticket details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getReportTransactionDetails = async (dispatch, user_id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/support/report-transaction-details/${user_id}`)
        .then((res) => {
            dispatch(getReportTransactionSuccess(res?.data || {}))
            return res?.data
        })
        .catch((error) => {
            toastMessage("Report transaction details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getReportRefundDetails = async (dispatch, user_id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/support/report-refund-details/${user_id}`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Report refund details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getTransactionDetails = async (dispatch, user_id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/support/transaction-details/${user_id}`)
        .then((res) => {
            dispatch(getReportTransactionSuccess(res?.data || {}))
            return res?.data
        })
        .catch((error) => {
            toastMessage("Transaction details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getUserTransactionDetails = async (dispatch, user_id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/support/user-transaction-details/${user_id}`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("User transaction details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getSessionDetails = async (dispatch, user_id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/support/session-details/${user_id}`)
        .then((res) => {
            dispatch(getSessionSuccess(res?.data || {}))
            return res?.data
        })
        .catch((error) => {
            toastMessage("Session details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getUserSessionDetails = async (dispatch, user_id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/support/user-session-details/${user_id}`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("User session details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getSessionMessages = async (dispatch, user_id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/support/session-messages/${user_id}`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Session messages not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getAgentDetails = async (dispatch, agent_id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/support/agent-details/${agent_id}`)
        .then((res) => {
            dispatch(getAgentSuccess(res?.data || {}))
            return res?.data
        })
        .catch((error) => {
            toastMessage("Agent details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getUserDetails = async (dispatch, user_id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/support/user-details/${user_id}`)
        .then((res) => {
            dispatch(getUserSuccess(res?.data || {}))
            return res?.data
        })
        .catch((error) => {
            toastMessage("User details not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


// ===============================================================================
// ================================== POST API ===================================
// ===============================================================================

export const postRefund = async (dispatch, refund_data) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .post(`/support/refund`, refund_data)
        .then((res) => {
            toastMessage("Refund process successfully complete", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Refund process failed", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};
